export const ACTION_LOGS = 'Action logs';
export const ENROLLMENT_HISTORY = 'Enrollment History';
export const RISKS = 'Risks';
export const ENROLLMENT_HISTORY_PANEL = 'Enrollment history panel';
export const PLATFORM_CREATE_FROM_SCRATCH = 'platform-create-from-scratch';
export const PLATFORM_CREATE_FROM_TEMPLATE = 'platform-create-from-template';
export const PLATFORM_CREATE_FROM_PARAM_TEMPLATE = 'platform-create-from-param-template';
export const WORKFLOW_CHANGES = 'Workflow Changes';
export const PERFORMANCE = 'Performance';
export const PLATFORM_NOTIFICATION_SETTINGS = 'platform-notification-settings';
export const DEFAULT_TAB = 'default';
export const AT_RISK_TAB = 'at-risk';
export const CLEANUP_TAB = 'cleanup';
export const DELETED_TAB = 'deleted';
export const CUSTOM_TAB = 'custom';